import { render, staticRenderFns } from "./SpecialInfo.vue?vue&type=template&id=027c5dd7&scoped=true&"
import script from "./SpecialInfo.vue?vue&type=script&lang=js&"
export * from "./SpecialInfo.vue?vue&type=script&lang=js&"
import style0 from "./SpecialInfo.vue?vue&type=style&index=0&id=027c5dd7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027c5dd7",
  null
  
)

export default component.exports